export default __webpack_public_path__ + "static/media/MHR.620e6e75.svg";